import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';

import ZRMUtils from '@zg-rentals/zrm-utils-js/lib/utils';
import {
    Button,
    Flex,
    Heading,
    Spacer,
    Text,
} from '@zillow/constellation';
import { Container } from '@zillow/zrs-comet';

import { UserSelectors } from 'app/shared/selectors';
import EmailVerificationActions from 'app/shared/actions/EmailVerificationActions';

const EmailVerificationPage = ({ location }) => {
    const dispatch = useDispatch();
    const isUserBlocked = useSelector(state => UserSelectors.makeIsUserBlocked(state));
    const [isVerifying, setIsVerifying] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [redirectPath, setRedirectPath] = useState('');

    const { path } = ZRMUtils.queryUtils.parsePathAndQueryParams(location.pathname);
    const pathArr = path.split('/');
    const securityToken = pathArr[pathArr.length - 2];

    useEffect(() => {
        if (!isUserBlocked && securityToken) {
            dispatch(EmailVerificationActions.verifySecurityToken(securityToken))
                .then(({ response }) => {
                    // removes https://www.zillow.com from redirectPath (always zillow.com even in local env)
                    const trimmedRedirectUrl = response.successRedirectUrl.substring(22);
                    setRedirectPath(trimmedRedirectUrl);
                })
                .catch((err) => {
                    setErrorMessage(err.message);
                })
                .finally(() => setIsVerifying(false));
        } else {
            // should we display a message if the user is blocked?
        }
    }, []);

    const handleRedirect = () => {
        window.router.transitionTo(redirectPath);
    };

    return (
        <Container className="EmailVerificationPage">
            <Spacer margin="xl">
                <Flex display="flex" alignItems="center" flexDirection="column">
                    <Heading level={3}>Email Verification</Heading>
                    <Spacer margin="sm">
                        {isVerifying && <Heading level={4}>Verifying...</Heading>}
                    </Spacer>
                    <Text>{errorMessage}</Text>
                    {!isVerifying && !errorMessage && (
                        <>
                            <Redirect to={redirectPath} />
                            <Text> If the page does not redirect automatically...</Text>
                            <Button onClick={handleRedirect}>Click here</Button>
                        </>
                    )}
                </Flex>
            </Spacer>
        </Container>
    );
};

export default EmailVerificationPage;
